import 'babel-polyfill';
import 'abortcontroller-polyfill/dist/polyfill-patch-fetch';
import 'whatwg-fetch';

class XHR {
  constructor(url, options = {}) {
    this.url         = url;
    this.method      = this.optionOrDefaultFor(options.method,      'GET');
    this.headers     = this.optionOrDefaultFor(options.headers,     {});
    this.body        = this.optionOrDefaultFor(options.body,        {});
    this.credentials = this.optionOrDefaultFor(options.credentials, 'same-origin');
    this.onSuccess   = this.optionOrDefaultFor(options.onSuccess,   this.defaultOnSuccess);
    this.onError     = this.optionOrDefaultFor(options.onError,     this.defaultOnError);
    this.controller  = new AbortController();

    this.execute();
  }

  optionOrDefaultFor(value, defaultValue) {
    if (value === undefined) {
      return defaultValue;
    } else {
      return value;
    }
  }

  defaultOnSuccess() {
    // ...
  }

  defaultOnError(e) {
    if (e.name == 'AbortError') {
      return;
    }

    if (_.isFunction(PT.Utils.trackError)) {
      PT.Utils.trackError(e);
    }
  }

  validateResponse(response) {
    if (response.ok) {
      return Promise.resolve(response);
    }

    return Promise.reject(new Error(response.statusText));
  }

  parseJSON(response) {
    return response.json();
  }

  nonGetRequest() {
    const methods = ['POST', 'PUT', 'DELETE'];

    return _.includes(methods, this.method.toUpperCase());
  }

  execute() {
    let options = {
      method: this.method,
      headers: this.headers,
      credentials: this.credentials,
      signal: this.controller.signal,
    };

    if (this.nonGetRequest()) {
      options.body = JSON.stringify(this.body);
    }

    fetch(this.url, options)
      .then(this.validateResponse)
      .then(this.parseJSON)
      .then(this.onSuccess)
      .catch(this.onError);
  }

  abort() {
    this.controller.abort();
  }
}

// Usage Notes for Rails
// -----------------------------------------------------------------
// 1) CSRF Token
//
//    When sending non-API requests (internal Rails actions), we
//    need to send the CSRF token in the header
//
//    Ex:
//      import { CSRF_TOKEN } from './constants';
//
//      xhr(`/path.json`, {
//        headers: { 'X-CSRF-Token': CSRF_TOKEN },
//        ...
//      });
//
// 2) POST/PUT/DELETE with JSON
//
//    When sending non-GET requests (ex: posting JSON), we need to set
//    the proper header for that
//
//    Ex:
//      xhr(`/path.json`, {
//        headers: { 'Content-Type': 'application/json' },
//        body: { key: 'value' },
//        ....
//    });
//

module.exports = (url, options) => {
  return new XHR(url, options);
}
